import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Cor de um token (`--accent-600`, `--line`…) como `rgb(r g b)`, para
 * bibliotecas que escrevem atributos SVG — onde `var()` não é resolvido.
 * Lê o <html>, por isso segue o `data-product` ativo.
 */
export function tokenColor(name: string, fallback = '#64748b'): string {
  if (typeof document === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim()
  return value ? `rgb(${value})` : fallback
}
